var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStayAndWait2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.871 18.106v-7.937C39.871 5.612 36.694 4 33.706 4H15.962c-2.986 0-6.165 1.612-6.165 6.17v7.936A5.038 5.038 0 0 0 6 22.993v12.715c0 3.76 2.506 5.217 4.983 5.359v3.224A1.696 1.696 0 0 0 12.692 46h1.754a1.701 1.701 0 0 0 1.708-1.709v-3.224h17.41v3.224A1.696 1.696 0 0 0 35.273 46h1.754a1.701 1.701 0 0 0 1.708-1.709v-3.224c3.651-.188 4.98-2.845 4.98-5.36v-12.76a5.188 5.188 0 0 0-3.844-4.841zM15.962 5.679h17.744c1.671 0 4.457.568 4.457 4.457v7.782a5.054 5.054 0 0 0-4.595 5.012v1.186H16.104v-1.169a5.054 5.054 0 0 0-4.595-5.012v-7.749c-.004-3.893 2.795-4.507 4.453-4.507zm.142 20.158h17.41v5.886h-17.41v-5.886zm-1.67 18.454h-1.755v-3.224h1.754v3.224zm20.776 0v-3.224h1.754v3.224H35.21zm6.737-8.583c0 1.67-.618 3.7-3.7 3.7H11.409c-1.67 0-3.7-.618-3.7-3.7V22.947a3.37 3.37 0 1 1 6.737 0v9.607a.835.835 0 0 0 .835.835H34.4a.834.834 0 0 0 .856-.835v-9.607a3.367 3.367 0 0 1 6.733 0v12.76h-.041z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStayAndWait2);
export default __webpack_public_path__ + "static/media/stay-and-wait2.6f367c9cba3d0eb235360fa10f9d5b40.svg";
export { ForwardRef as ReactComponent };